import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../shared/user-login/login.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators  } from '@angular/forms';

@Component({
    selector: 'app-pwd-change',
    templateUrl: './pwd-change.component.html',
    styleUrls: ['./pwd-change.component.css'],
    standalone: false
})
export class PwdChangeComponent implements OnInit {
  userDetails
  role: string;
  name: string;
  serverErrorMessages: string;
  loading: boolean = true
  passwordChangeForm = new FormGroup({
    oldPassword: new FormControl('',[Validators.required]),
    newPassword: new FormControl('',[Validators.required]),
    confirmPassword: new FormControl('',[Validators.required]),
    otp: new FormControl('',[Validators.required])
  })
  otpSent: boolean = false;
  constructor(public loginService: LoginService, private router: Router) { }

  ngOnInit(): void {
    if(this.loginService.isLoggedIn()){
     //console.log("Yo I am Logged in still");
      this.loginService.getUserProfile().subscribe(
        res => {
          this.userDetails = res['user'];
          this.role = res['user'].role.toString();
          this.name = res['user'].fullName.toString();
          this.loading = false;
         //console.log('Got user', this.userDetails, this.role)
        },
        err => {
          this.loading = false;
         //console.log('Did not get user', err);
        });
    }
  }

  onSubmit(){
    if(!this.otpSent){
    const cred = {
      userId: this.userDetails._id,
      // newPassword: this.passwordChangeForm.get('oldPassword').value,
      oldPassword: this.passwordChangeForm.get('oldPassword').value
    }
   //console.log(cred)

    this.loginService.changePassword(cred).subscribe(
      res => {
       //console.log('Inside OnSubmit, response', res);
        //added router to navigate to profile after password change
        // this.router.navigateByUrl('/signin');
        // window.alert("Password changed successfully");

      },
      err => {
       //console.log('Error Changing Password', err);
        // window.alert("Unable to change password");
        this.serverErrorMessages = err.error.message;
        // console.log(this.serverErrorMessages)
      });}
      else if(this.otpSent){
       //console.log('came here only')
        const cred = {
          userName: this.userDetails.userName,
          otp:  this.passwordChangeForm.get('otp').value,
          newPassword: this.passwordChangeForm.get('newPassword').value,
        }
       console.log(this.passwordChangeForm.get('otp').value)
        this.loginService.resetPassword(cred).subscribe(
          data => {
           //console.log('Success');
            // this.successMessage = data.message;
            alert("password changed successfully !");
            setTimeout(() => {
              this.logout()
            }, 2000);
          },
          err => {
           //console.log('Error', err);
            this.serverErrorMessages = err.error.message
            console.log(this.serverErrorMessages)
          }
        )
      }
  }

  hideEmail(email) {
    return email.replace(/(.{2})(.*)(?=@)/,
      function(gp1, gp2, gp3) {
        for(let i = 0; i < gp3.length; i++) {
          gp2+= "*";
        } return gp2;
      });
  }

  sendOTP(){
    this.serverErrorMessages = "";
    setTimeout(()=>{
      if(this.serverErrorMessages=="Current Password Not matched")
      {
        this.otpSent = false;
      }
      else
      {
        this.otpSent = true;
      }
      
    }, 3000)
  }

  logout(){
    this.role='';
    
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }

}
